export default async (forms) => {
  const promises = [];
  forms.forEach((form) => {
    promises.push(form.$refs[`form`].form.validate());
  });
  const pr = await Promise.all(promises);
  return pr.filter((item) => item).length === forms.length;
};
